module.exports = __webpack_public_path__ + "media/img/logos/2024/horizontal/frauentag-b1b3db0c30a96f369913fb8c70dc059e.svg";